import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import Copyright from '../../common/components/layout/Copyright';
import LoginButton from '../../common/components/LoginButton';
import {Card, CardGroup, CardText, CardTitle} from '../../common/look';
import ResetPasswordForm from './ResetPasswordForm';
import LogoHeader from './LogoHeader';
import config from '../../config/app';

const ResetPasswordView = ({t, token}) => {
  const [isReset, setReset] = useState(false);

  const renderMetaData = () => (
    <Helmet
      title={`${config.name} - ${t('resetPass.title')}`}
      meta={[
        {
          name: 'description',
          content: `${config.name} - ${t('resetPass.meta')}`,
        },
      ]}
    />
  );

  const renderConfirmationModal = () => (
    <Card className="confirm-email">
      <CardGroup>
        <CardTitle>{t('resetPass.confirmationMsgTitle')}</CardTitle>
        <CardText>{t('resetPass.confirmationMsgBody')}</CardText>
        <LoginButton>
          <Link to="/login" className="button-link">
            {t('reg.back')}
          </Link>
        </LoginButton>
      </CardGroup>
    </Card>
  );

  return (
    <Container className="container-full register-container">
      {renderMetaData(t)}
      <React.Fragment>
        <LogoHeader/>
        {isReset ? renderConfirmationModal() : <ResetPasswordForm token={token} setReset={setReset}/>}
        <Row>
          <Col xs={12} className="white-centered copyright">
            <Copyright/>
          </Col>
        </Row>
      </React.Fragment>
      )}
    </Container>
  );
};

ResetPasswordView.propTypes = {
  t: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

export default ResetPasswordView;
